export class UserZone {
  id: bigint;
  group_id: number;
  user_id: bigint;
  zone_id: bigint;
  user_name: string;
  zone_name: string;
  lager: string;
  location: string;
  activate: boolean;
  info1: string;
  info2: string;
}
